import {useRef} from 'react';
import {Popover, Table} from "antd";
import {CategoryType, ProductType, ProductSubType} from "../../api/Constants";
import {getColumnSearchProps} from "../widget/SearchProps";
import {Link} from 'react-router';


export const SimpleProductTable = ({inventory, props}) => {
    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                return <Popover content={'View Product'}>
                    <Link to={`/product/${encodeURIComponent(record.id)}`}>{val}</Link>
                </Popover>
            },
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
            ...getColumnSearchProps('name', searchInput)
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            render: (val, record, index) => {
                return CategoryType.Label[val];
            },
            sorter: (a, b) => a.category - b.category
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (val, record, index) => {
                return ProductType.Label[val]
            },
            sorter: (a, b) => a.type - b.type,
        },
        {
            title: 'Sub Type',
            dataIndex: 'subtype',
            key: 'subtype',
            render: (val, record, index) => {
                return ProductSubType.Label[val];
            },
            sorter: (a, b) => a.subtype - b.subtype,
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku'
        },
    ];

    return <Table dataSource={inventory} columns={columns} pagination={false}/>
}